import { NgModule } from '@angular/core';
import { InputComponent } from './input.component';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { PasswordModule } from 'primeng/password';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [InputComponent],
  imports: [
    CommonModule,
    InputTextModule,
    InputNumberModule,
    InputMaskModule,
    PasswordModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [InputComponent],
})
export class InputComponentModule {}
